import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export const  Loader = () => <AiOutlineLoading3Quarters className='spin' />

export default Loader
